// extracted by mini-css-extract-plugin
export default {"container":"dC_d","title":"dC_c0","subtitle":"dC_hk","tickContainer":"dC_mC","tick":"dC_mD","container_active":"dC_mF","containerActive":"dC_mF"};